import { useMemo, useState } from 'react';
import {
  RESOURCE_LIBRARY,
  RESOURCE_TYPE_META,
  RESOURCE_TYPE_ORDER,
} from '../data/resourcesData';

const TYPE_FILTERS = RESOURCE_TYPE_ORDER.filter((t) => t !== 'all');

export default function ResourcesPage() {
  const [typeFilter, setTypeFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  const normalizedQuery = searchQuery.trim().toLowerCase();

  const filteredResources = useMemo(() => {
    return RESOURCE_LIBRARY.filter((resource) => {
      const matchesType = typeFilter === 'all' || resource.type === typeFilter;
      const matchesQuery =
        !normalizedQuery ||
        resource.title.toLowerCase().includes(normalizedQuery) ||
        (resource.summary && resource.summary.toLowerCase().includes(normalizedQuery)) ||
        (resource.detailLine && resource.detailLine.toLowerCase().includes(normalizedQuery));
      return matchesType && matchesQuery;
    });
  }, [typeFilter, normalizedQuery]);

  return (
    <div className="rl-page">
      <div className="rl-topbar">
        <h1 className="rl-title">RESOURCE LIBRARY</h1>
        <button type="button" className="rl-upload-btn">
          <svg viewBox="0 0 16 16" width="14" height="14" fill="none" aria-hidden="true">
            <path d="M8 2v9M4.5 5l3.5-3 3.5 3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2 12h12" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
          </svg>
          Upload Resource
        </button>
      </div>

      <div className="rl-controls">
        <div className="rl-search-wrap">
          <svg className="rl-search-icon" viewBox="0 0 16 16" aria-hidden="true">
            <path d="M11.5 10.5l3.25 3.25" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
            <circle cx="7" cy="7" r="4.6" stroke="currentColor" strokeWidth="1.4" fill="none" />
          </svg>
          <input
            type="search"
            className="rl-search-input"
            placeholder="Search resources..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            aria-label="Search resources"
          />
        </div>

        <div className="rl-type-filters">
          <button
            type="button"
            className={`rl-chip ${typeFilter === 'all' ? 'active' : ''}`}
            onClick={() => setTypeFilter('all')}
          >
            All
          </button>
          {TYPE_FILTERS.map((typeId) => {
            const meta = RESOURCE_TYPE_META[typeId];
            return (
              <button
                key={typeId}
                type="button"
                className={`rl-chip ${typeFilter === typeId ? 'active' : ''}`}
                onClick={() => setTypeFilter((prev) => (prev === typeId ? 'all' : typeId))}
              >
                {meta.emoji} {meta.label}
              </button>
            );
          })}
        </div>
      </div>

      {filteredResources.length > 0 ? (
        <div className="rl-grid">
          {filteredResources.map((resource) => {
            const meta = RESOURCE_TYPE_META[resource.type];
            return (
              <article key={resource.id} className="rl-card">
                <div className="rl-card-header">
                  <span className="rl-type-badge">
                    {meta?.emoji} {meta?.label}
                  </span>
                  {resource.isNew && <span className="rl-new-badge">New</span>}
                </div>
                <h3 className="rl-card-title">{resource.title}</h3>
                <p className="rl-card-detail">{resource.summary || resource.detailLine}</p>
                <div className="rl-card-footer">
                  <span className="rl-card-meta">{resource.detailLine}</span>
                  <button type="button" className="rl-open-btn">Open</button>
                </div>
              </article>
            );
          })}
        </div>
      ) : (
        <div className="rl-empty">
          <p>No resources found.</p>
          <button
            type="button"
            className="rl-chip active"
            onClick={() => { setTypeFilter('all'); setSearchQuery(''); }}
          >
            Clear filters
          </button>
        </div>
      )}
    </div>
  );
}
